import { ShieldAlert } from "lucide-react";

const Box = ({ title, children, id }) => (
  <div className="card-surface" data-testid={id}><div className="label-xs mb-3">{title}</div>{children}</div>
);

export default function MarketPanels({ market }) {
  if (!market) return <div className="card-surface text-sm text-muted-foreground">Title map, themes and knockouts appear after analysis.</div>;
  const max = Math.max(...market.title_map.map((t) => t.count), 1);
  return (
    <>
      <Box title={`Title map (${market.jd_count} JDs)`} id="title-map">
        {market.title_map.map((t) => (
          <div key={t.title} className="flex items-center gap-2 text-sm py-0.5">
            <span className="flex-1 truncate">{t.title}</span>
            <div className="w-24 h-1.5 bg-slate-800 rounded-full"><div className="h-full bg-emerald-500 rounded-full" style={{ width: `${(100 * t.count) / max}%` }} /></div>
            <span className="font-mono text-xs w-6 text-right">{t.count}</span>
          </div>
        ))}
      </Box>
      <Box title="Knockout requirements" id="knockouts">
        {market.knockouts.map((k, i) => (
          <div key={i} className="flex gap-2 text-sm py-1"><ShieldAlert size={14} className="text-rose-400 mt-0.5 shrink-0" />
            <span className="flex-1"><span className="text-xs uppercase text-slate-500 mr-1">{k.type}</span>{k.requirement}</span>
            <span className="font-mono text-xs text-slate-400">{k.approx_pct}%</span>
          </div>
        ))}
      </Box>
      <Box title="Responsibility themes" id="themes">
        <ol className="space-y-2 text-sm">{market.themes.map((t, i) => <li key={i}><span className="font-medium">{t.theme}.</span> <span className="text-slate-400">{t.description}</span></li>)}</ol>
      </Box>
      <Box title="Exact recruiter phrases" id="recruiter-phrases">
        <div className="flex flex-wrap gap-1.5">{market.recruiter_phrases.map((p, i) => <span key={i} title={p.example} className="text-xs px-2 py-1 rounded-md bg-slate-800 text-slate-300">"{p.phrase}"</span>)}</div>
      </Box>
    </>
  );
}
